import React from "react";

import { faCopy } from "@awesome.me/kit-4c83d50d0d/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import copy from "copy-to-clipboard";

import Button from "~/ui/button";
import Input from "~/ui/Input";
import { Modal } from "~/ui/legacyFellowIndex";
import toast from "~/ui/toast";

import styles from "./ApiKeyGeneratedModal.module.css";

interface ApiKeyGeneratedModalProps {
	token: string;
	name: string;
	onClose: () => void;
}

export default function ApiKeyGeneratedModal({ token, name, onClose }: ApiKeyGeneratedModalProps) {
	const onCopy = React.useCallback(() => {
		copy(token);
		toast.success("API key copied to clipboard");
	}, [token]);

	return (
		<Modal onClose={onClose} width="40rem">
			<Modal.Header onClose={onClose}>
				<Modal.Title>API Key Generated</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className={styles.title}>{name}</div>
				<p className={styles.subtitle}>
					This is the only time you’ll be able to view your API key.
					<br />
					Please copy and store it in a secure location, you won’t be able to see it again.
				</p>
				<div className={styles.tokenRow}>
					<Input readOnly value={token} className={styles.tokenInput} name="generated_api_key" />
					<Button variant="primary" size="normal" onClick={onCopy} className={styles.copyButton}>
						<FontAwesomeIcon icon={faCopy} /> Copy
					</Button>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<Button size="normal" variant="secondary" onClick={onClose}>
					Close
				</Button>
			</Modal.Footer>
		</Modal>
	);
}
